export default __webpack_public_path__ + "static/media/profile.8c18f4c6.svg";